import styled from 'styled-components';

import { Typography } from '@mui/material';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  align-items: center;

  > svg {
    fill: ${({ theme }) => theme.palette.warning.main};
    width: ${({ theme }) => theme.spacing(6.5)};
    height: ${({ theme }) => theme.spacing(6.5)};
  }
`;
export const ErrorMessage = styled(Typography)`
  color: ${({ theme }) => theme.palette.text.secondary};
  text-align: center;
  margin-top: ${({ theme }) => theme.spacing(1.25)};
`;
